import { notEmpty } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import type { PreloadedQuery } from "react-relay";
import { graphql, useFragment, usePreloadedQuery } from "react-relay";

import { query } from "~/components/search/search-explore-topics";
import type { searchExploreTopicsListQueue$key } from "~/queries/__generated__/searchExploreTopicsListQueue.graphql";
import type { searchExploreTopicsQuery } from "~/queries/__generated__/searchExploreTopicsQuery.graphql";

import { StyledTopic, StyledTopicLink } from "./styles";

export type Props = {
  queryReference: PreloadedQuery<searchExploreTopicsQuery>;
};

export const SearchExploreTopicsList: FunctionComponent<Props> = ({ queryReference }) => {
  const data = usePreloadedQuery<searchExploreTopicsQuery>(query, queryReference);

  const fragment = useFragment<searchExploreTopicsListQueue$key>(
    graphql`
      fragment searchExploreTopicsListQueue on Queue {
        items(first: $first) {
          edges {
            node {
              __typename
              ... on Topic {
                entityId
                ...topicLinkTopic
              }
            }
          }
        }
      }
    `,
    data.queue,
  );

  return (
    <div>
      {fragment?.items?.edges.filter(notEmpty).map(({ node }) => {
        switch (node.__typename) {
          case "Topic":
            return (
              <StyledTopic key={node.entityId}>
                <StyledTopicLink reference={node} />
              </StyledTopic>
            );
          default:
            return null;
        }
      })}
    </div>
  );
};

SearchExploreTopicsList.displayName = "SearchExploreTopicsList";
